module.exports = __webpack_public_path__ + "assets/img/miaoshu01.e4958962.png";